// JS-1986: request header telling ErrorInterceptor not to toast this request's error, for callers that
// report failures themselves (one summary instead of a toast per request). Stripped before sending.
export const SILENT_ERROR_HEADER = 'X-Silent-Error';
